<div class="flex flex-row items-center gap-4">
  <button  (click)="addNewUser()" class="primary-btn my-4">Add User</button>
  <button mat-mini-fab aria-label="view columns button" (click)="showFilters=!showFilters">
    <mat-icon>filter_list</mat-icon>
  </button>
</div>

<div class="flex flex-row gap-4" *ngIf="showFilters">

  <mat-form-field appearance="fill">
    <mat-label>Email</mat-label>
    <input matInput [(ngModel)]="conditions.Email" name="Email">
    <mat-icon matPrefix>email</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>FirstName</mat-label>
    <input matInput [(ngModel)]="conditions.FirstName" name="FirstName">
    <mat-icon matPrefix>label</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>LastName</mat-label>
    <input matInput [(ngModel)]="conditions.LastName" name="LastName">
    <mat-icon matPrefix>label</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Phone</mat-label>
    <input matInput [(ngModel)]="conditions.Phone" name="Phone">
    <mat-icon matPrefix>phone</mat-icon>
  </mat-form-field>


  <mat-form-field appearance="fill">
    <mat-label>Company</mat-label>
    <mat-select [(ngModel)]="conditions.companyID" name="companyID">
      <mat-option *ngFor="let company of selectOptions" [value]="company.ID">{{ company.Name }}</mat-option>
    </mat-select>
    <mat-icon matPrefix>domain</mat-icon>
  </mat-form-field>

  <div class="flex flex-grow"></div>

  <div class="flex flex-row gap-2 my-2">
    <div>
      <button class="primary-btn" (click)="applyConditions()">Apply</button>
    </div>
    <div>
      <button class="base-btn !bg-red-500 !text-white" (click)="clearConditions()">Clear</button>
    </div>
  </div>

</div>

<mat-table [dataSource]="dataSource" matSort class="!w-full !inline-table table-alternate">

  <ng-container matColumnDef="ID">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
    <td mat-cell *matCellDef="let element"> {{ element.ID }} </td>
  </ng-container>

  <ng-container matColumnDef="Email">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
    <td mat-cell *matCellDef="let element"> {{ element.Email }} </td>
  </ng-container>

  <ng-container matColumnDef="FirstName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>FirstName</th>
    <td mat-cell *matCellDef="let element">{{ element.FirstName }}</td>
  </ng-container>

  <ng-container matColumnDef="LastName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>LastName</th>
    <td mat-cell *matCellDef="let element">{{ element.LastName }}</td>
  </ng-container>

  <ng-container matColumnDef="Phone">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
    <td mat-cell *matCellDef="let element">{{ element.Phone }}</td>
  </ng-container>

  <ng-container matColumnDef="UserGroupID">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>User Group</th>
    <td mat-cell *matCellDef="let element">{{ element.Name }}</td>
  </ng-container>

  <ng-container matColumnDef="Company">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Company</th>
    <td mat-cell *matCellDef="let element">{{ element.Company}}</td>
  </ng-container>
  
  <ng-container matColumnDef="isActive">
    <th mat-header-cell *matHeaderCellDef>Active</th>

    <td mat-cell *matCellDef="let element">
      <mat-slide-toggle
        [checked]="(element.isActive ?? 0) == 1"
        (change)="onActiveToggle(element, $event.checked)"
        [disabled]="element.__activeLoading"
      >
        {{ ((element.isActive ?? 0) == 1) ? 'Active' : 'Inactive' }}
      </mat-slide-toggle>
    </td>
  </ng-container>

  <!-- RTL BUTTONS -->
  <!-- <ng-container matColumnDef="text_direction">
    <th mat-header-cell *matHeaderCellDef>Direction</th>
    <td mat-cell *matCellDef="let element">
      <mat-slide-toggle
        [checked]="(element.text_direction || 'ltr') === 'rtl'"
        (change)="onDirectionToggle(element, $event.checked)"
        [disabled]="element.__dirLoading"
      >
        {{ (element.text_direction || 'ltr') | uppercase }}
      </mat-slide-toggle>
    </td>
  </ng-container> -->


  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Delete</th>
    <td mat-cell *matCellDef="let element">
      <div class="flex flex-row gap-2">
        <button mat-icon-button (click)="editUser(element)"
          class="!bg-slate-500 !text-white">
          <mat-icon>edit</mat-icon>
        </button>
  
        <button mat-icon-button (click)="openDeleteUserConfirm(element)"
          class="!bg-red-500 !text-white">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </td>
  </ng-container>

  <!-- Header and Row Definitions -->
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</mat-table>

<mat-paginator [length]="totalItems" [pageSize]="12" showFirstLastButtons>
</mat-paginator>

<!-------------------------------------------------------------------------------------------------------------------->

<ng-template #userFormTmpl>
  <app-user-form [formData]="selectedUser" (onSubmitClbk)="onSubmitClbk($event)"></app-user-form>
</ng-template>

<ng-template #confirmDeleteTmpl>
  <div class="flex flex-col gap-4">
    <p>Are you sure you want to delete <b>{{ selectedUser.FirstName }}</b>?</p>
    <div class="flex flex-row items-center justify-center gap-2">
      <button mat-button (click)="deleteUser()">Confirm</button>
      <button mat-button (click)="dialog.closeAll();">Cancel</button>
    </div>
  </div>
</ng-template>